import { attendeeFetchData, attendeeSendData } from "./index";

const eventEvaluationsAPI = {
  fetch: (attendeeId, sessionId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/evaluation-questions`),
  send: (attendeeId, sessionId, data) => attendeeSendData(`/api/v2/attendees/${attendeeId}/evaluation-questions`, data),
}

export default eventEvaluationsAPI;